import { MatrixProduct } from './matrix-product.model';
import { Fabric } from './product-fabric.model';

export class FabricProducts {
  public fabric: Fabric;
  public total: number;
  public matrixProducts: MatrixProduct[];
  public disabled?: boolean;

  // this info comes nowadays from a random product inside the fabric product
  public description?: string;
  public imageUrl?: string;
  public launchDate?: string;
}
